<div class="section-header">
  <div class="title">{{ TemplateNodeTitle || ('audit.node.addArticleElement.articles' | translate) }}</div>
</div>

<div>
  <itl-card-2 *ngFor="let article of articles" class="article-list-item">
    <itl-article-list-item
      [article]="article"
      [showCheckbox]="true"
      [checked]="article.isChecked !== false"
      [dosage]="dosage"
      [labels]="labels"
      (checkedChange)="handleCheckBoxChanged($event, article._id)"
    ></itl-article-list-item>
    <!-- <ng-template #actions>
      <itl-icon-button icon="alberta-trash" (click)="handleRemove(article._id)"></itl-icon-button>
    </ng-template> -->
    <ng-template #dosage>
      {{ article?.quantity }} {{ article.unit | articleUnitPipe }} ({{ 'singleOrder.quantity' | translate }}: {{
      article?.packagingUnit?.quantity }} {{ 'article.edit.units.stk' | translate }})
    </ng-template>
    <ng-template #labels>
      <itl-label *ngIf="article.pharmacyOnly" [labelStyle]="'infoLabel'" [icon]="'alberta-pharmacy-only'"
        >{{ 'article.details.pharmacyOnly' | translate }}
      </itl-label>
    </ng-template>
    <div class="annotation-container">
      <itl-card-2>
        <itl-textarea
          [title]="'annotation' | translate"
          (change)="handleAnnotationChange($event.target.value, article._id)"
          icon="alberta-comment"
          [placeholder]="'audit.node.addAnnotation' | translate"
          [(ngModel)]="article.annotation"
        >
        </itl-textarea>
      </itl-card-2>
    </div>
  </itl-card-2>
</div>
